import React from "react";
import { Row } from "@tanstack/react-table";
import { tableGrouperFeatures } from "../../../../components/src/react-table/features";
import { percentageFormat, accountReturn, benchmarkReturn, diffReturn } from "./functions";
import { BenchmarkData } from "./interfaces";

export const accountReturnElement = (
    row: Row<typeof tableGrouperFeatures, any>,
    dateSeries: string[],
    startDate: Date,
    endDate: Date,
    accountSeriesById: Record<string, number[]>,
    annualized = false
) => {
    // Not Applicable for cash accounts?
    if (!row.getIsGrouped() && row.original.isPartyInstrument) return <div style={{ textAlign: "right" }}>{"N.A."}</div>;

    const calculatedReturn = accountReturn(row, dateSeries, startDate, endDate, accountSeriesById, annualized);
    return calculatedReturn === null ? null : <div style={{ textAlign: "right" }}>{percentageFormat(calculatedReturn)}</div>;
};
export const benchmarkReturnElement = (
    row: Row<typeof tableGrouperFeatures, any>,
    dateSeries: string[],
    startDate: Date,
    endDate: Date,
    benchmarksById: Record<string, BenchmarkData>,
    accountPositionsById: Record<string, number[]>,
    modelSeriesById: Record<string, number[]>,
    useModelSeriesAsMain = true,
    annualized = false
) => {
    if (!row.getIsGrouped() && row.original.isPartyInstrument) return <div style={{ textAlign: "right" }}>{"N.A."}</div>;
    const calculatedReturn = benchmarkReturn(
        row,
        dateSeries,
        startDate,
        endDate,
        benchmarksById,
        accountPositionsById,
        modelSeriesById,
        useModelSeriesAsMain,
        annualized
    );
    return calculatedReturn === null ? null : <div style={{ textAlign: "right" }}>{percentageFormat(calculatedReturn)}</div>;
};
export const diffReturnElement = (
    row: Row<typeof tableGrouperFeatures, any>,
    dateSeries: string[],
    startDate: Date,
    endDate: Date,
    benchmarksById: Record<string, BenchmarkData>,
    accountSeriesById: Record<string, number[]>,
    accountPositionsById: Record<string, number[]>,
    modelSeriesById: Record<string, number[]>,
    useModelSeriesAsMain = true,
    annualized = false
) => {
    if (!row.getIsGrouped() && row.original.isPartyInstrument) return <div style={{ textAlign: "right" }}>{"N.A."}</div>;
    const calculatedReturn = diffReturn(
        row,
        dateSeries,
        startDate,
        endDate,
        benchmarksById,
        accountSeriesById,
        accountPositionsById,
        modelSeriesById,
        useModelSeriesAsMain,
        annualized
    );
    return calculatedReturn === null ? null : <div style={{ textAlign: "right" }}>{percentageFormat(calculatedReturn)}</div>;
};
